import {
  Button,
  ButtonGroup,
  ButtonLayout,
  ButtonSize,
  ButtonVariant,
  Dialog,
  H4,
  P,
  TypePreset,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";

import {
  DocumentVerifierProps,
  VerifierState,
} from "./DocumentVerifierContainer";

import { ToTranslate } from "src/components/i18n";

export const UploadDocumentDialog = ({
  open,
  setDocumentVerifierState,
}: DocumentVerifierProps) => (
  <>
    <Dialog
      as="div"
      open={open}
      closeAction={{
        label: "Close",
        onClose: () => setDocumentVerifierState(null),
        position: "absolute",
      }}
      header={{
        content: (
          <>
            <H4 preset={TypePreset.Heading_02}>
              <ToTranslate>Select a document to upload</ToTranslate>
            </H4>
          </>
        ),
        gutterH: 1.5,
      }}
      footer={{
        content: (
          <ButtonGroup arrangement={["column-center", null, "row-end-reverse"]}>
            <Button
              variant={ButtonVariant.PrimaryOnLight}
              size={ButtonSize.Sm}
              layout={[ButtonLayout.Full, null, ButtonLayout.Inline]}
              onClick={() =>
                setDocumentVerifierState(VerifierState.VerifyingDocument)
              }
            >
              <ToTranslate>Upload document</ToTranslate>
            </Button>
            <Button
              variant={ButtonVariant.TextOnLight}
              size={ButtonSize.Sm}
              layout={[ButtonLayout.Full, null, ButtonLayout.Inline]}
              onClick={() => setDocumentVerifierState(null)}
            >
              <Trans>Cancel</Trans>
            </Button>
          </ButtonGroup>
        ),
        gutterH: 3,
        separator: true,
      }}
    >
      <P>TODO: LIST OF DOCUMENTS</P>
    </Dialog>
  </>
);
